export const gendersConst = (t) => [
    {
        label: t("Male"),
        value: "MALE"
    },   {
        label: t("Female"),
        value: "FEMALE"
    }
]
